/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { CurrencyValueModel } from './currency-value.model';
import { DelCustomerVO } from './del-customer-vo.model';
import { TimeAvailabilityModel } from './time-availability.model';

export class OfferMRSTemplateMetadata extends JSONable {

  totalCost: CurrencyValueModel | undefined = undefined;

  customerVO: DelCustomerVO | undefined = undefined;

  spOfferRequestUuid: string | undefined = undefined;

  minimumOfferTimeAvailability: TimeAvailabilityModel | undefined = undefined;
}
